import { render, staticRenderFns } from "./ScrollTip.vue?vue&type=template&id=039a14f2&scoped=true&"
import script from "./ScrollTip.vue?vue&type=script&lang=js&"
export * from "./ScrollTip.vue?vue&type=script&lang=js&"
import style0 from "./ScrollTip.vue?vue&type=style&index=0&id=039a14f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039a14f2",
  null
  
)

export default component.exports